export class PagesizeType {
  static readonly EVENTS = 'EVENTS_PAGESIZE';
  static readonly GROUP_RESERVATIONS_SUMMARY = 'GROUP_RESERVATIONS_SUMMARY_PAGESIZE';
  static readonly GROUP_RESERVATIONS_NO_MATCHES = 'GROUP_RESERVATIONS_NO_MATCHES_PAGESIZE';
  static readonly GROUP_RESERVATIONS_PARTIAL_MATCHES = 'GROUP_RESERVATIONS_PARTIAL_MATCHES_PAGESIZE';
  static readonly GROUP_RESERVATIONS_EXACT_MATCHES = 'GROUP_RESERVATIONS_EXACT_MATCHES_PAGESIZE';
  static readonly RSVP_SUMMARY = 'RSVP_SUMMARY_PAGESIZE';
  static readonly RSVP_NO_MATCHES = 'RSVP_NO_MATCHES_PAGESIZE';
  static readonly RSVP_PARTIAL_MATCHES = 'RSVP_PARTIAL_MATCHES_PAGESIZE';
  static readonly RSVP_EXACT_MATCHES = 'RSVP_EXACT_MATCHES_PAGESIZE';
  static readonly TRANSIENT_RESERVATIONS = 'TRANSIENT_RESERVATIONS_PAGESIZE';
  static readonly PAYMENT_RESERVATIONS = 'PAYMENT_RESERVATIONS_PAGESIZE';
  static readonly PAYMENT_RSVP = 'PAYMENT_RSVP_PAGESIZE';
  static readonly MATCHING_PROPERTY = 'MATCHING_PROPERTY_PAGESIZE';
  static readonly EVENT_MATCHING = 'EVENT_MATCHING_PAGESIZE';
  static readonly MATCHING_AGENCY = 'MATCHING_AGENCY_PAGESIZE';
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/pagination/pagesize-type.ts